import http from '../common/http-auth'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getAllApiToken = async (clientId?: number) => {
    // Explicitly handle null, undefined, 0, and NaN cases
    const url = (clientId != null && !isNaN(clientId) && clientId !== 0) ? `/apitoken/all?clientId=${clientId}` : '/apitoken/all';
    // Send the GET request
    const response = await http.get(url);
    // Return the response
    return response;
}


// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getAllApiTokenById = async (id?: number) => {
    const response = http.get(`/apitoken/${id !== undefined ? id : ''}`)
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
export const addApiToken = async (data: any) => {
    const response = http.post(`/apitoken/add`, data)
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
export const deleteApiToken= async (id: number, deletedBy: number) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const response = await http.delete(`/apitoken/delete`, {
        params: { id, deletedBy },
      });
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
export const activatedeactivate = async (id: number, activeOrDeActive:number, updateBy: number) => {
    const response = await http.put(`/apitoken/activate?id=${id}&activeOrDeActive=${activeOrDeActive}&updateBy=${updateBy}`, {
        params: { id, activeOrDeActive, updateBy },
      });
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
export const updateApiToken = async (data: any) => {
    const response = http.put(`/apitoken/update`, data)
    return response;
}
